import { IPromise } from "angular";
import type { ApiResponse } from "src/AngularJS/Models/api-response.model";
import { ModuleManagerModuleSettings } from "src/shared/models/module-manager/module-manager-settings.models";

export enum ModuleManagerExportFormat {
    Excel = 'excel',
    ExcelNoObjectives = 'excelNoObjectives',
    CSV = 'csv',
    PNG='png'
}

export enum ModuleManagerRefreshType {
    Auto = 'auto',
    Default = 'default',
    Hour = 'hour',
    Long = 'long',
    FiveMinute = 'fiveMinute',
    Minute = 'minute',
    CAS = 'cas',
    CASShort = 'casShort',
    VeryShort = 'veryShort',
    FifteenMinute = 'fifteenMinute',
    FourHour = 'fourHour',
}

export class ModuleManagerOptions {
    /** The default name to display on the module */
    name?: string;
    /** Determines whether or not there is a Refresh menu item */
    isDefaultName?: boolean;
    /** Indicates whether the name is set to the default name for this module */
    hasRefresh?: boolean;
    /** If true, the module will calculate a class based on its size to be used in CSS */
    enableWidthClass?: boolean;
    /** If true, the module will not have a header and instead have the ellipsis icon on the right */
    widgetMode?: boolean;
    /** The type of refresh the module would like to request. */
    refreshType?: ModuleManagerRefreshType;
    /** A function that will be called when the module is being transferred. Should return an object to be stored in memory. */
    getTransferObject?: () => object;
    /** A function that will be called when a module is restored */
    onTransferLoaded?: (transferObject: Record<string, any>) => void;
    /** A function that will be called to check if a module is able to be refreshed */
    canRefresh?: () => boolean;
    /** A function that will be called when export is clicked. It should return the promise response with file data. */
    onExport?: (format: ModuleManagerExportFormat, isCXOne?: boolean) => IPromise<ApiResponse<string>>;
    /** A function that will be called when export PNG is clicked. */
    onImageExport?: (isCXOne?: boolean) => void;
    imageExportVisible?: () => boolean;
    /** A function that will be called when settings are done applying (or loaded) */
    onSettingsApplied?: (settings: ModuleManagerModuleSettings) => void;
    /** A function that will be called when it is time for a module to refresh data */
    onRefresh?: (isAutoRefresh: boolean) => void;

    /** Name set by user */
    customName?: string;
    /** Temporary name for editing customName */
    editName?: string;
    /** Suffix set by module */
    nameSuffix?: string;
}

export interface ICXoneCustomWidgetError {
    TitleTextSection: string;
    TitleTextKey: string;
    ButtonTextSection: string;
    ButtonTextKey: string;
    ButtonClickEvent: () => void;
    ShowBoxIcon: boolean;
};
